export * from './client.interface';
export * from './socketClient.interface';
export * from './socketEvent.interface';
export * from './currentGame.interface';